import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ef868cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "events-title" }, " Upcoming Events ", -1))

import { onMounted, ref } from 'vue'
import Header from '@/components/Header.vue'
import JoinCommunity from '@/components/Content/JoinCommunity.vue'
import Footer from '@/components/Footer.vue'
import EventTile from '@/components/Events/EventTile.vue'
import useEvents from '@/components/Events/useEvents'
import { wrapGrid } from 'animate-css-grid'


export default /*#__PURE__*/_defineComponent({
  __name: 'Events',
  setup(__props) {

const { events, getEvents, selectedEvent } = useEvents()

const grid = ref<HTMLElement>()

onMounted(async () => {
  await getEvents()
  wrapGrid(grid.value as HTMLElement, { easing: 'backOut', stagger: 10, duration: 400 })
})

const handleSelect = (index: number) => {
  selectedEvent.value = index
}

const handleMousedown = (event: MouseEvent) => {
  if (event.target instanceof Element && grid.value && !grid.value.contains(event.target)) {
    selectedEvent.value = -1
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, { class: "header" }),
    _createElementVNode("div", {
      class: "events-container",
      onMousedown: handleMousedown
    }, [
      _hoisted_1,
      _createElementVNode("div", {
        ref_key: "grid",
        ref: grid,
        class: "events-grid"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(events)?.items, (event, index) => {
          return (_openBlock(), _createBlock(EventTile, {
            key: index,
            selected: _unref(selectedEvent) === index,
            event: event.fields,
            onClick: ($event: any) => (handleSelect(index))
          }, null, 8, ["selected", "event", "onClick"]))
        }), 128))
      ], 512)
    ], 32),
    _createVNode(JoinCommunity, { class: "join-community" }),
    _createVNode(Footer)
  ]))
}
}

})